<template lang='pug'>
  IMList(:title='title' :listType='listType' :dialogType="dialogType" :im='getIM()')
</template>

<script>
import IMList from "../components/IMList.vue";
import * as i18n from "../data/i18n.json";
export default {
  name: "IMRequest",
  components: {
    IMList
  },
  data() {
    return {
      i18n: i18n.default,
      title: 'Approval Page',
      listType: 'approval',
      dialogType: 'spv',
      im: {
        headers: [
          {
            text: "IM Number",
            value: "imNo"
          },
          {
            text: "Subject",
            value: "imPerihal"
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
          }
        ],
        items: [],
        bisnisUnit: '',
        paymentHeaders: [
          {
            text: "IM Number",
            value: "imNo",
            width: '14%',
          },
          {
            text: "Subject",
            value: "imPerihal",
            width: '30%',
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
            width: '12%',
          }
        ],
        jumlah:0
      }
    }
  },
  mounted () {
    // this.$store.dispatch("fetchDataApprovalRefactor")
  },
  methods: {
    getIM () {
      this.im.items = this.$store.state.dataReqApproval.data || [];
      this.im.jumlah = this.$store.state.dataReqApproval.jumlah || 0
      
      if(this.im.items){
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel = this.i18n.status[this.im.items[i].imStatus].name;
          this.im.items[i].imTypeLabel = this.i18n.imType[this.im.items[i].imType];
          if (this.im.items[i].imStatus == 2) {
            let workflow = this.im.items[i].imWorkflow;
            for (let j = 0; j < workflow.length; j++) {

              // UNUSED +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
              // for (let k in this.$store.state.dataUsers.user.bu) {
              //   if (this.$store.state.dataUsers.user.bu[k].id === workflow[j].id) {
              //     this.im.items[i].imStatusLabel = this.i18n.status[this.im.items[i].imStatus].name;
              //     if (workflow[j].status == 9) {
              //       this.im.items[i].imStatusLabel = this.i18n.status[workflow[j].status].name;
              //       // this.im.items[i].imStatus = workflow[j].status;
              //       break;
              //     }
              //   }
              // }
              if (this.$store.state.dataUsers.user._id === workflow[j].user_id) {
                this.im.items[i].imStatusLabel = this.i18n.status[this.im.items[i].imStatus].name;
                if (workflow[j].status == 9) {
                  this.im.items[i].imStatusLabel = this.i18n.status[workflow[j].status].name;
                  // this.im.items[i].imStatus = workflow[j].status;
                  break;
                }
              }
            }
          }
          // const localization = this.im.items[i].imValue.currency == 'USD' ? 'en-US': 'id-ID';
          // const formatter = new Intl.NumberFormat(localization, {
          //   style: 'currency',
          //   currency: this.im.items[i].imValue.currency,
          //   minimumFractionDigits: 0
          // })
          // this.im.items[i].imNilai = formatter.format(this.im.items[i].imValue.value);
          this.im.items[i].imUserName = this.im.items[i].imUser.fullname;
          
          if ( this.im.items[i].hasOwnProperty('imCategory') ) {
            for( const data of this.i18n.category ) {
              if ( data.value == this.im.items[i].imCategory ) {
                this.im.items[i].imCategory = data.text
              }
            }
          } else if (this.im.items[i].imType == 6 || this.im.items[i].imType == 7) {
            this.im.items[i].imCategory = "N/A"
          } else {
            this.im.items[i].imCategory = "General"
          }
        }
      }

      return this.im;
    },
  }
};
</script>
